import colors from "./helpers/colors";

// a little different then GenericColorMapping
/** @type {ColorMap} */
export default {
  // strike zone
  strikeZone: colors.grey.alto,
  strikeZoneSectors: colors.grey.alto,
  foulLine: colors.grey.alto,
  grassLine: colors.grey.alto,

  hiddenSeries: 'transparent',
  default: colors.blue.default,
};
